require('./RALandingSuccess.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const RAResumeBox = require('../commons/RAResumeBox/RAResumeBox');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @utilities
const { traceFlowEvent } = require('utilities/contactCenter/wrapUp/wrapUpCore');

// @constants
const {
    OPERATION_LOG_TYPE_FINISH,
    OPERATION_LOG_DONE,
} = require('utilities/contactCenter/wrapUp/constants');

class RALandingSuccess extends React.Component {
    componentDidMount() {
        const { onRender } = this.props;
        if (__CONTACT_CENTER__) {
            traceFlowEvent.notify(
                OPERATION_LOG_TYPE_FINISH,
                OPERATION_LOG_DONE,
            );
        }
        if (!!onRender) {
            onRender();
        }
    }
    buildOptionalButton() {
        return (
            <OKButton
                id="success-optional"
                modifier="ghost"
                to={this.props.optionalButtonURL}
            >
                {this.props.optionalButton}
            </OKButton>
        );
    }
    render() {
        const {
            title,
            resumeContent,
            info,
            mainButton,
            optionalButton,
            children,
        } = this.props;
        let optional;
        if (optionalButton) {
            optional = this.buildOptionalButton();
        }
        return (
            <div className="ra-landing-success">
                <div className="ra-landing-success__resume">
                    <RAResumeBox title={title} content={resumeContent} />
                </div>
                <div className="ra-landing-success__info">{info}</div>
                <div className="ra-landing-success__informative-box">
                    {children}
                </div>
                <div className="ra-landing-success__line" />
                <div className="ra-landing-success__button">
                    <div className="ra-landing-success__button-optional">
                        {optional}
                    </div>
                    <div className="ra-landing-success__button-main">
                        <OKButton
                            id="success-main"
                            modifier="secondary"
                            to={this.props.mainButtonURL}
                        >
                            {mainButton}
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }
}

RALandingSuccess.propTypes = {
    children: PropTypes.any,
    info: PropTypes.string,
    mainButton: PropTypes.string.isRequired,
    mainButtonURL: PropTypes.string.isRequired,
    onRender: PropTypes.func,
    optionalButton: PropTypes.string,
    optionalButtonURL: PropTypes.string,
    resumeContent: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = RALandingSuccess;
